export const state = {
  cidades: {},
  cidadess: [],
};

export default {};
